import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import users from 'modules/core/store/collections/users'

import type { ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import { usePerformanceModuleContext } from 'modules/performance/hooks/usePerfomanceModuleContext'
import { NewCustomPerformanceReview } from 'modules/reviews/components/ChooseNewReviewModal/NewCustomReviewModal/CreateReviewModal'
import { NewPerformanceReview } from 'modules/reviews/components/ChooseNewReviewModal/NewReviewModal'
import { NewPerformanceReviewFromTemplate } from 'modules/reviews/components/ChooseNewReviewModal/TemplatesPage'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { userIsManagingPeople } from 'modules/teams/store/userIsManagingPeople'

type ModalType = 'ChooseNewReviewModal' | 'CustomReviewModal' | 'TemplateReviewModal'
type Props = {
  onClose: () => void
  contractVersions: ContractVersions
}

export const ChooseNewReviewModal: React.FC<Props> = ({ onClose, contractVersions }) => {
  const { hasFullVisibility } = usePerformanceModuleContext()
  const canSeeReviewTemplate =
    hasFullVisibility || userIsManagingPeople(teams, memberships, users.current.id)
  const defaultModal: ModalType = canSeeReviewTemplate
    ? 'ChooseNewReviewModal'
    : 'CustomReviewModal'
  const [currentModal, setCurrentModal] = React.useState<ModalType | null>(defaultModal)

  const closeModal = () => {
    setCurrentModal(null)
    onClose()
  }

  React.useEffect(() => {
    track(trackingEvents.reviews.createStartReview)
  }, [])

  return (
    <Box aria-label={'Create a review action'}>
      {currentModal === 'ChooseNewReviewModal' && (
        <NewPerformanceReview
          onClose={onClose}
          onSubmitCustomReview={() => setCurrentModal('CustomReviewModal')}
          onSubmitReviewFromTemplate={() => setCurrentModal('TemplateReviewModal')}
        />
      )}
      {currentModal === 'CustomReviewModal' && (
        <NewCustomPerformanceReview onClose={closeModal} contractVersions={contractVersions} />
      )}
      {currentModal === 'TemplateReviewModal' && (
        <NewPerformanceReviewFromTemplate onClose={closeModal} />
      )}
    </Box>
  )
}
